import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/content";
import { useWaitlist } from "@/context/WaitlistContext";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { openWaitlist } = useWaitlist();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setMobileOpen(false), [location.pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "border-b border-[#4B2E5A]/5 bg-[#FCFAF7]/80 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <img
            src="/assets/logo.png"
            alt="Naari Sutra — Simplifying Daily Decisions"
            className="h-14 w-auto object-contain md:h-16"
          />
        </Link>

        <div className="hidden items-center gap-9 md:flex">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-[#4B2E5A]/70 transition-colors hover:text-[#4B2E5A]"
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:block">
          <button
            data-testid="nav-early-access-btn"
            onClick={() => openWaitlist("General")}
            className="rounded-full bg-[#4B2E5A] px-6 py-2.5 text-sm font-medium text-[#FCFAF7] shadow-[0_8px_30px_rgba(75,46,90,0.15)] transition-all hover:bg-[#4B2E5A]/90 hover:-translate-y-0.5"
          >
            Join Early Access
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="text-[#4B2E5A] md:hidden"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X /> : <Menu />}
        </button>
      </nav>

      {mobileOpen && (
        <div data-testid="mobile-menu" className="border-t border-[#4B2E5A]/5 bg-[#FCFAF7]/95 px-6 py-4 backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-base font-medium text-[#4B2E5A]/80"
              >
                {l.label}
              </Link>
            ))}
            <button
              onClick={() => openWaitlist("General")}
              className="mt-2 rounded-full bg-[#4B2E5A] px-6 py-3 text-sm font-medium text-[#FCFAF7]"
            >
              Join Early Access
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
